import { FC } from 'react';
import type { Answer } from '@teachur/http-client';
import { Check } from 'lucide-react';

interface AnswerOptionProps {
  answer: Answer;
  isSelected: boolean;
  onSelect: () => void;
}

export const AnswerOption: FC<AnswerOptionProps> = ({ answer, isSelected, onSelect }) => {
  return (
    <button
      type="button"
      onClick={onSelect}
      className="flex items-center gap-2.5 lg:gap-3.75 text-left cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span
        className={`flex items-center justify-center w-4.5 h-4.5 lg:w-8 lg:h-8 rounded-[4px] lg:rounded-[6px] border border-(--neutral-black-NB700) shrink-0 ${isSelected ? 'bg-(--neutral-black-NB1000)' : 'bg-(--neutral-white-NW1000)'}`}
      >
        {isSelected && <Check className="text-(--neutral-white-NW1000)" />}
      </span>
      <span
        className={`[font-family:var(--font-montserrat)] [font-size:var(--fs-p3)]! lg:[font-size:var(--fs-p2)]!
        ${isSelected ? 'text-(--neutral-black-NB1000) font-semibold' : 'text-(--neutral-black-NB700)'}`}
      >
        {answer.text}
      </span>
    </button>
  );
};
